import { render, staticRenderFns } from "./intro-content.vue?vue&type=template&id=3e813880&scoped=true&"
import script from "./intro-content.vue?vue&type=script&lang=js&"
export * from "./intro-content.vue?vue&type=script&lang=js&"
import style0 from "./intro-content.vue?vue&type=style&index=0&id=3e813880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e813880",
  null
  
)

export default component.exports